adminEntitiesApi.$inject = ['$http', '$q', 'configuration']

export default function adminEntitiesApi($http, $q, config) {
  var endPoint = config.apiEndPoint
    const getApiUrl = (path) => `${endPoint}`.replace('/api/v1', '/api/v2') + path;

    return {
      // Supergroup API methods
      listSupergroups: function(params = {}) {
        return $http.get(getApiUrl('/admin_entities/supergroups/'), { params }).then(response => ({ data: response.data }));
      },

      getSupergroup: function(uuid) {
        return $http.get(getApiUrl(`/admin_entities/supergroups/${encodeURIComponent(uuid)}`)).then(response => ({ data: response.data }));
      },

      createSupergroup: function(supergroup) {
        return $http.post(getApiUrl('/admin_entities/supergroups/'), supergroup).then(response => ({ data: response.data }));
      },

      updateSupergroup: function(supergroup) {
        return $http.put(getApiUrl(`/admin_entities/supergroups/${encodeURIComponent(supergroup.uuid)}`), supergroup).then(response => ({ data: response.data }));
      },

      deleteSupergroup: function(uuid) {
        return $http.delete(getApiUrl(`/admin_entities/supergroups/${encodeURIComponent(uuid)}`)).then(response => ({ data: response.data }));
      },

      // Subgroup API methods
      listSubgroups: function(params = {}) {
        return $http.get(getApiUrl('/admin_entities/subgroups'), { params }).then(response => ({ data: response.data }));
      },

      createSubgroup: function(subgroup) {
        return $http.post(getApiUrl('/admin_entities/subgroups'), subgroup).then(response => ({ data: response.data }));
      },

      updateSubgroup: function(subgroup) {
        return $http.put(getApiUrl(`/admin_entities/subgroups/${encodeURIComponent(subgroup.uuid)}`), subgroup).then(response => ({ data: response.data }));
      },

      deleteSubgroup: function(uuid) {
        return $http.delete(getApiUrl(`/admin_entities/subgroups/${encodeURIComponent(uuid)}`)).then(response => ({ data: response.data }));
      },

      // Domain API methods
      listDomains: function(params = {}) {
        return $http.get(getApiUrl('/admin_entities/domains'), { params }).then(response => ({ data: response.data }));
      },

      getDomain: function(uuid, params = {}) {
        return $http.get(getApiUrl(`/admin_entities/domains/${encodeURIComponent(uuid)}`), { params }).then(response => ({ data: response.data }));
      },

      updateDomain: function(domainUuid, propsToUpdate) {
        return $http.put(getApiUrl(`/admin_entities/domains/${encodeURIComponent(domainUuid)}`), propsToUpdate).then(response => ({ data: response.data }));
      },

      getDomainsInSupergroupTree: function(supergroupId) {
        return $http.get(getApiUrl(`/admin_entities/supergroups/${encodeURIComponent(supergroupId)}/domains`)).then(response => ({ data: response.data }));
      },

      fetchNormalizedUsersInSupergroup(supergroupUuid) {
        return $http.get(`${endPoint}/supergroup/${encodeURIComponent(supergroupUuid)}/normalized_users`).then(response => ({ data: response.data }));
      },

      // User API Methods
      addUsersToSubgroups: function(userUuids, subgroupUuids, domainUuid) {
        return $http.put(getApiUrl(`/admin_entities/users/subgroups`), { user_uuids: userUuids, subgroup_uuids: subgroupUuids, domain_uuid: domainUuid, op: "add" }).then(response => ({ data: response.data }));
      },

      removeUsersFromSubgroups: function(userUuids, subgroupUuids, domainUuid) {
        return $http.put(getApiUrl(`/admin_entities/users/subgroups`), { user_uuids: userUuids, subgroup_uuids: subgroupUuids, domain_uuid: domainUuid, op: "remove" }).then(response => ({ data: response.data }));
      },

      // Subgroup Rules API methods
      listSubgroupRules: function(params = {}) {
        return $http.get(getApiUrl('/admin_entities/subgroup_rules'), { params }).then(response => ({ data: response.data }));
      },

      getSubgroupRule: function(uuid) {
        return $http.get(getApiUrl(`/admin_entities/subgroup_rules/${encodeURIComponent(uuid)}`)).then(response => ({ data: response.data }));
      },

      createSubgroupRule: function(rule) {
        return $http.post(getApiUrl('/admin_entities/subgroup_rules'), rule).then(response => ({ data: response.data }));
      },

      updateSubgroupRule: function(rule) {
        return $http.put(getApiUrl(`/admin_entities/subgroup_rules/${encodeURIComponent(rule.uuid)}`), rule).then(response => ({ data: response.data }));
      },

      deleteSubgroupRule: function(uuid) {
        return $http.delete(getApiUrl(`/admin_entities/subgroup_rules/${encodeURIComponent(uuid)}`)).then(response => ({ data: response.data }));
      },
    };
  };